import React, { useCallback, useContext, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretLeft, faCaretRight, faTimes } from '@fortawesome/free-solid-svg-icons';
import {
  AppBar, Box,
  ButtonGroup, IconButton, Tab, Tabs, Typography, useTheme,
} from '@mui/material';
import PropTypes from 'prop-types';
import WinManagerContext from '../../providers/winManagerProvider';

function ManagerLink({ menuExpanded }) {
  const {
    dellComponentFromWindowsManager,
    linkComponents,
    currentURL,
    nextWindow,
    prevWindow,
    // windowsStack,
  } = useContext(WinManagerContext);
  const history = useHistory();
  const theme = useTheme();
  const t = theme.transitions.create(['left']);
  const onCloseIconClick = useCallback(
    (e, value) => {
      e.preventDefault();
      e.stopPropagation();
      dellComponentFromWindowsManager(value);
    },
    [dellComponentFromWindowsManager],
  );
  const knowUrls = useMemo(
    () => linkComponents.map((l) => l.url),
    [linkComponents],
  );
  const tabValue = useMemo(
    () => (knowUrls.includes(currentURL) ? currentURL : false),
    [currentURL, knowUrls],
  );
  return (
    <AppBar
      position="fixed"
      // color="transparent"
      id="LinksManager"
      component="section"
      elevation={1}
      sx={{
        transition: t,
        bgcolor: 'grey.100',
        flexDirection: 'row',
        width: 'auto',
        bottom: 0,
        left: menuExpanded ? theme.menu.expanded.width : theme.menu.shrinked.width,
        right: 0,
        top: 'auto',
        height: theme.footer.height,
      }}
    >
      <ButtonGroup size="small">
        <IconButton
          onClick={() => prevWindow(history)}
        >
          <FontAwesomeIcon icon={faCaretLeft} />
        </IconButton>
        <IconButton
          onClick={() => nextWindow(history)}
        >
          <FontAwesomeIcon icon={faCaretRight} />
        </IconButton>
      </ButtonGroup>
      <Tabs
        value={tabValue}
        onChange={(e, v) => history.push(v)}
        variant="scrollable"
        TabScrollButtonProps={{ sx: { color: 'text.primary' } }}
        scrollButtons="auto"
      >
        {
          linkComponents.map(({ title, url }) => (
            <Tab
              key={`link-key-${url}`}
              sx={{ alignSelf: 'start' }}
              label={(
                <Box display="flex" alignItems="baseline">
                  <Typography variant="subtitle2" sx={{ mr: 1 }}>
                    {title}
                  </Typography>
                  <FontAwesomeIcon
                    icon={faTimes}
                    onClick={(e) => onCloseIconClick(e, url)}
                  />
                </Box>
              )}
              value={url}
            />
          ))
        }
      </Tabs>
    </AppBar>
  );
}

ManagerLink.propTypes = {
  menuExpanded: PropTypes.bool.isRequired,
};
export default ManagerLink;
